import { createRef } from 'react'
import { Box, DateField } from '@machobear/design-system'
import { useField, useFormikContext } from 'formik'
import noop from 'lodash/noop'
import useFocusOnError from '@/hooks/use-focus-on-error'

type DateFieldInputProps<V> = {
  id: string
  minDate?: Date
  maxDate?: Date
  name: string
  value: V
  label: string
  onChange?: NonNullable<(value: V) => unknown>
  onBlur?: () => unknown
  message?: string
  tone?: 'critical' | 'neutral' | 'positive' | 'caution'
  required?: boolean
  disabled?: boolean
}

export const DateFieldInput = ({
  name,
  onChange = noop,
  onBlur = noop,
  required = false,
  disabled = false,
  ...props
}: DateFieldInputProps<Date | null>) => {
  const fieldRef = createRef<HTMLDivElement>()
  const [, meta] = useField(name)
  const { error, touched } = meta
  const formik = useFormikContext()
  useFocusOnError({ fieldRef, name })

  const onChangeField = (e: any) => {
    onChange(e)
    formik.setFieldValue(name, e)
  }

  return (
    <Box ref={fieldRef}>
      <DateField
        name={name}
        onChange={onChangeField}
        required={required}
        disabled={disabled}
        message={error && touched ? error : null}
        tone={error && touched ? 'critical' : 'neutral'}
        {...props}
      />
    </Box>
  )
}
